import * as React from 'react';
import { Box, Button, Tooltip } from 'wix-style-react';
export var DummyButton = function (_a) {
    var toolTipContent = _a.toolTipContent, buttonTitle = _a.buttonTitle, dataHook = _a.dataHook;
    return (React.createElement(Tooltip, { placement: "bottom", content: toolTipContent, dataHook: "".concat(dataHook, "-tooltip") },
        React.createElement(Box, { pointerEvents: 'none' },
            React.createElement(Button, { skin: "light", dataHook: "".concat(dataHook, "-button") }, buttonTitle))));
};
//# sourceMappingURL=DummyButton.js.map